import Vue from 'vue';
import Account from '@/views/Account/Account.vue';
import EmailConfirmation from '@/views/EmailConfirmation/EmailConfirmation.vue';
import SignIn from '@/views/Auth/SignIn.vue';
import SignUp from '@/views/SignUp/SignUp.vue';
import SignUpComplete from '@/views/SignUp/SignUpComplete.vue';
import AffiliateSignUp from '@/views/SignUp/AffiliateSignUp.vue';
import ForgotPassword from '@/views/Auth/ForgotPassword.vue';
import Layers from '@/components/Layers/Layers.vue';
import WarningModal from '@/components/Modals/WarningModal.vue';
import VueRouterWrapper from '@/views/VueRouterWrapper.vue';
import TemplateProductPodAssignerModal from '@/components/TemplateProductPodAssignerModal/TemplateProductPodAssignerModal.vue';
import VariantsConfiguratorModal from '@/components/TemplateProductPodAssigner/VariantsConfigurator/VariantsConfiguratorModal.vue';
import TemplateProductSpecsModal from '@/components/TemplateProductSpecsModal/TemplateProductSpecsModal.vue';
import CErrorModal from '@/components/CErrorModal.vue';
import DesigningForHeader from '@/components/DesigningForHeader.vue';
import ScopesUpdateModal from '@/components/ScopesUpdateModal.vue';
import Step3SaveTemplateModal from '@/components/CreateProduct/Step3SaveTemplateModal.vue';
import EtsyStoreNeedsReconnectionModal from '@/components/EtsyStoreNeedsReconnectionModal/EtsyStoreNeedsReconnectionModal.vue';
import SortUpdateModal from '@/components/SortUpdateModal.vue';
import CCustomCheckbox from '@/components/shared/CCustomCheckbox.vue';
import CButton from '@/components/shared/CButton';
import ElementTransformProperties from '@/components/DesignStudio/ElementTransformProperties.vue';
import TextCharacterProperties from '@/components/DesignStudio/TextCharacterProperties.vue';
import TextColorProperties from '@/components/DesignStudio/TextColorProperties.vue';
import VectorColorProperties from '@/components/DesignStudio/VectorColorProperties.vue';
import ImageColorProperties from '@/components/DesignStudio/ImageColorProperties.vue';
import MaskProperties from '@/components/DesignStudio/MaskProperties.vue';
import ImageShadowProperties from '@/components/DesignStudio/ImageShadowProperties.vue';
import DynamicVectorProperties from '@/components/DesignStudio/DynamicVectorProperties.vue';
import DynamicImageProperties from '@/components/DesignStudio/DynamicImageProperties.vue';
import ImageToImageProperties from '@/components/DesignStudio/ImageToImageProperties.vue';
import TemplateProductVariantsModal from '@/components/DesignStudio/TemplateProductVariantsModal.vue';
import ImageEffectsProperties from '@/components/DesignStudio/ImageEffectsProperties/ImageEffectsProperties.vue';
import CrosswordProperties from '@/components/DesignStudio/CrosswordProperties/CrosswordProperties.vue';
import ImageEffectsTestPrompt from '@/components/DesignStudio/ImageEffectsTestPrompt.vue';
import MapStyleProperties from '@/components/DesignStudio/MapStyleProperties/MapStyleProperties.vue';
import CanvasContextMenu from '@/components/DesignStudio/CanvasContextMenu.vue';
import CanvasSelectionToolbar from '@/components/DesignStudio/CanvasSelectionToolbar.vue';
import FontsReplacementMatcherModal from '@/components/Modals/FontsReplacementMatcherModal.vue';
import CanvasToolbarTop from '@/components/DesignStudio/CanvasToolbarTop/CanvasToolbarTop.vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import ResetPreviewModal from '@/components/DesignStudio/ResetPreviewModal.vue';
import PreviewBackgroundModal from '@/components/DesignStudio/PreviewBackgroundModal.vue';
import TextShadowProperties from '@/components/DesignStudio/TextShadowProperties.vue';
import TextAdvancedProperties from '@/components/DesignStudio/TextAdvancedProperties.vue';
import TextShapeProperties from '@/components/DesignStudio/TextShapeProperties.vue';
import PatternProperties from '@/components/DesignStudio/PatternProperties.vue';
import TextPathProperties from '@/components/DesignStudio/TextPathProperties.vue';
import ProductBaseResume from '@/components/DesignStudio/ProductBaseResume.vue';
import WordCloudTester from '@/components/DesignStudio/WordCloud/Tester.vue';
import WordCloudShapeProperties from '@/components/DesignStudio/WordCloud/ShapeProperties.vue';
import WordCloudColorProperties from '@/components/DesignStudio/WordCloud/ColorProperties.vue';
import WordCloudCharacterProperties from '@/components/DesignStudio/WordCloud/CharacterProperties.vue';
import ElementsLinkModal from '@/components/DesignStudio/ElementsLinkModal.vue';
import WordSearchCharacterProperties from '@/components/DesignStudio/WordSearch/CharacterProperties.vue';
import WordSearchTester from '@/components/DesignStudio/WordSearch/WordSearchTester.vue';
import WordSearchColorProperties from '@/components/DesignStudio/WordSearch/ColorProperties.vue';
import WordSearchGridProperties from '@/components/DesignStudio/WordSearch/GridProperties.vue';
import CalendarGeneralProperties from '@/components/DesignStudio/Calendar/GeneralProperties.vue';
import CalendarMonthYearProperties from '@/components/DesignStudio/Calendar/MonthYearProperties.vue';
import CalendarDaysProperties from '@/components/DesignStudio/Calendar/DaysProperties.vue';
import CalendarSelectedDateProperties from '@/components/DesignStudio/Calendar/SelectedDateProperties.vue';
import QrCodeTester from '@/components/DesignStudio/QrCode/QrCodeTester.vue';
import QrCodeStyleProperties from '@/components/DesignStudio/QrCode/StyleProperties.vue';
import QrCodeColorProperties from '@/components/DesignStudio/QrCode/ColorProperties.vue';
import Sidebar from '@/components/Layout/Sidebar.vue';
import SwitchTeamModal from '@/components/Layout/SwitchTeamModal.vue';

console.log(`Running ${process.env.APP_RELEASE}`);
window.rumStartRecording = () => {
    window.DD_RUM && window.DD_RUM.startSessionReplayRecording();
};
window.rumStopRecording = () => {
    window.DD_RUM && window.DD_RUM.stopSessionReplayRecording();
};

async function loadPdfjsLib() {
    try {
        const pdfjsLibModule = await import(/* webpackChunkName: "pdfjsLib" */ 'pdfjs-dist/build/pdf');
        window.pdfjsLib = pdfjsLibModule;

        const workerSrc = new URL(
            /* webpackChunkName: "pdfjsWorker" */ 'pdfjs-dist/build/pdf.worker.min.js',
            import.meta.url
        ).toString();
        window.pdfjsLib.GlobalWorkerOptions.workerSrc = workerSrc;
    } catch (error) {
        console.error('Failed to load pdfjsLib or worker', error);
    }
}

Vue.config.errorHandler = function (err, vm, info) {
    // Log Vue.js errors so they are catch by Instana
    const errorString = `Vue.js error in '${info}' at component ${vm?.$options?.name || vm?.$vnode?.tag}: ${err}`;
    rumReportError(new Error(errorString));
    console.error(errorString);
};

// If appcues is not available (usually blocked) alert the user
if (!window.Appcues) {
    console.log('Appcues is not available');
    window.alert(
        'Your AdBlocker is blocking our welcome guide. Please make sure your AdBlocker is disabled for this site. We use this to provide announcements, tutorials and new features, no adds at all :D'
    );
}

(function () {
    'use strict';
    'ngInject';

    // On development ONLY, we can read the JWT token from the URL. On production the cookie from Shopify is under the same domain that core
    //  so it's shared automatically
    if (process.env.NODE_ENV === 'development') {
        const shToken = new URL(location.href).searchParams.get('shToken');
        if (shToken) {
            console.log('Received Shopify auth token');

            document.cookie = `userToken=${shToken}; expires=${new Date(
                new Date().getTime() + 24 * 60 * 60 * 1000
            ).toString()}; path=/;`;

            // Remove the token parameter
            const searchParams = new URLSearchParams(window.location.search);
            searchParams.delete('shToken');
            const searchString = searchParams.toString().length > 0 ? '?' + searchParams.toString() : '';
            const newUrl =
                window.location.protocol +
                '//' +
                window.location.host +
                window.location.pathname +
                searchString +
                window.location.hash;
            history.replaceState(null, '', newUrl);
        }
    } else {
        // Delete older non-HttpOnly cookie
        document.cookie = 'userToken=; path=/; expires=Thu, 01 Jan 1970 00:00:01 GMT';
    }

    loadPdfjsLib();

    // Template
    angular.module('templates', []).run([
        '$templateCache',
        function ($templateCache) {
            // Load templates used by ng-include
            $templateCache.put('angular-app/views/header.html', require('../views/header.html'));
            $templateCache.put('angular-app/views/sidebar.html', require('../views/sidebar.html'));
        }
    ]);

    // Services
    angular.module('app.shared.services', ['ngCookies']);

    // Directives
    angular.module('app.directives', ['app.shared.services', 'ngCookies']);

    // Controllers
    angular.module('app.ctrls', ['app.shared.services', 'ngCookies']);

    angular.module('app.vue.components', []);

    angular
        .module('app', [
            /* Templates */
            'templates',

            /* Angular modules */
            'ngRoute',
            'ngAnimate',
            'ngSanitize',
            'ngAria',
            'ngMessages',
            'ngMaterial',
            'ngCookies',
            'ngStorage',

            /* 3rd party modules */
            'blockUI',
            'ngFileUpload',
            'angular.filter',
            'flow',
            'ui.bootstrap',
            'ngAside',
            'ngAvatar',
            'ngVue',

            /* Custom modules */
            'app.ctrls',
            'app.directives',
            'app.shared.services',
            'app.vue.components'
        ])

        .config([
            '$httpProvider',
            function ($httpProvider) {
                $httpProvider.interceptors.push(function () {
                    return {
                        request: function (config) {
                            return config;
                        }
                    };
                });
            }
        ])

        // Theming
        .config(function ($mdThemingProvider) {
            $mdThemingProvider.theme('default').primaryPalette('indigo').accentPalette('indigo');
        })

        // To disable ng-animate use class --> ng-animate-disabled
        .config(function ($animateProvider) {
            $animateProvider.classNameFilter(/^(?:(?!ng-animate-disabled).)*$/);
        })

        // Block UI
        .config(function (blockUIConfig) {
            // Return false in the filter function to disable blockUI for that request
            blockUIConfig.requestFilter = function () {
                // Disable automatic blockUI
                return false;
            };
        })

        // Available to every scope through prototypal inheritance, so any button that must not be
        // re-clickable while an operation is in flight can use it in ng-disabled. Reads blockCount,
        // not `blocking`: the latter only flips after blockUIConfig.delay, leaving a click window.
        .run(function ($rootScope, blockUI) {
            $rootScope.isBusy = () => blockUI.state().blockCount > 0;
        })

        .config(function ($mdAriaProvider) {
            // Globally disables all ARIA warnings.
            $mdAriaProvider.disableWarnings();
        })

        .config(function ($sceDelegateProvider) {
            $sceDelegateProvider.resourceUrlWhitelist([
                // Allow same origin resource loads.
                'self',
                // Allow loading resources from our CDN
                `${process.env.VUE_APP_CLOUDFRONT_URL}/**`
            ]);
        });

    // Vue components registration
    angular.module('app.vue.components').value('Account', Account);
    angular.module('app.vue.components').value('EmailConfirmation', EmailConfirmation);
    angular.module('app.vue.components').value('SignIn', SignIn);
    angular.module('app.vue.components').value('SignUp', SignUp);
    angular.module('app.vue.components').value('SignUpComplete', SignUpComplete);
    angular.module('app.vue.components').value('AffiliateSignUp', AffiliateSignUp);
    angular.module('app.vue.components').value('ForgotPassword', ForgotPassword);
    angular.module('app.vue.components').value('Layers', Layers);
    angular.module('app.vue.components').value('VueRouterWrapper', VueRouterWrapper);
    angular.module('app.vue.components').value('TemplateProductPodAssignerModal', TemplateProductPodAssignerModal);
    angular.module('app.vue.components').value('VariantsConfiguratorModal', VariantsConfiguratorModal);
    angular.module('app.vue.components').value('TemplateProductSpecsModal', TemplateProductSpecsModal);
    angular.module('app.vue.components').value('FontsReplacementMatcherModal', FontsReplacementMatcherModal);
    angular.module('app.vue.components').value('CErrorModal', CErrorModal);
    angular.module('app.vue.components').value('DesigningForHeader', DesigningForHeader);
    angular.module('app.vue.components').value('ScopesUpdateModal', ScopesUpdateModal);
    angular.module('app.vue.components').value('EtsyStoreNeedsReconnectionModal', EtsyStoreNeedsReconnectionModal);
    angular.module('app.vue.components').value('WarningModal', WarningModal);
    angular.module('app.vue.components').value('Step3SaveTemplateModal', Step3SaveTemplateModal);
    angular.module('app.vue.components').value('SortUpdateModal', SortUpdateModal);
    angular.module('app.vue.components').value('font-awesome-icon', FontAwesomeIcon);
    angular.module('app.vue.components').value('c-custom-checkbox', CCustomCheckbox);
    angular.module('app.vue.components').value('CButton', CButton);
    angular.module('app.vue.components').value('TextPathProperties', TextPathProperties);
    angular.module('app.vue.components').value('ElementTransformProperties', ElementTransformProperties);
    angular.module('app.vue.components').value('TextCharacterProperties', TextCharacterProperties);
    angular.module('app.vue.components').value('TextColorProperties', TextColorProperties);
    angular.module('app.vue.components').value('VectorColorProperties', VectorColorProperties);
    angular.module('app.vue.components').value('ImageColorProperties', ImageColorProperties);
    angular.module('app.vue.components').value('MaskProperties', MaskProperties);
    angular.module('app.vue.components').value('ImageShadowProperties', ImageShadowProperties);
    angular.module('app.vue.components').value('DynamicVectorProperties', DynamicVectorProperties);
    angular.module('app.vue.components').value('DynamicImageProperties', DynamicImageProperties);
    angular.module('app.vue.components').value('TemplateProductVariantsModal', TemplateProductVariantsModal);
    angular.module('app.vue.components').value('ImageToImageProperties', ImageToImageProperties);
    angular.module('app.vue.components').value('ImageEffectsProperties', ImageEffectsProperties);
    angular.module('app.vue.components').value('CrosswordProperties', CrosswordProperties);
    angular.module('app.vue.components').value('ImageEffectsTestPrompt', ImageEffectsTestPrompt);
    angular.module('app.vue.components').value('ResetPreviewModal', ResetPreviewModal);
    angular.module('app.vue.components').value('PreviewBackgroundModal', PreviewBackgroundModal);
    angular.module('app.vue.components').value('MapStyleProperties', MapStyleProperties);
    angular.module('app.vue.components').value('CanvasContextMenu', CanvasContextMenu);
    angular.module('app.vue.components').value('CanvasSelectionToolbar', CanvasSelectionToolbar);
    angular.module('app.vue.components').value('TextShadowProperties', TextShadowProperties);
    angular.module('app.vue.components').value('TextAdvancedProperties', TextAdvancedProperties);
    angular.module('app.vue.components').value('TextShapeProperties', TextShapeProperties);
    angular.module('app.vue.components').value('PatternProperties', PatternProperties);
    angular.module('app.vue.components').value('ProductBaseResume', ProductBaseResume);
    angular.module('app.vue.components').value('CanvasToolbarTop', CanvasToolbarTop);
    angular.module('app.vue.components').value('WordCloudTester', WordCloudTester);
    angular.module('app.vue.components').value('WordCloudShapeProperties', WordCloudShapeProperties);
    angular.module('app.vue.components').value('WordCloudColorProperties', WordCloudColorProperties);
    angular.module('app.vue.components').value('WordCloudCharacterProperties', WordCloudCharacterProperties);
    angular.module('app.vue.components').value('Sidebar', Sidebar);
    angular.module('app.vue.components').value('SwitchTeamModal', SwitchTeamModal);
    // Word Search components
    angular.module('app.vue.components').value('WordSearchCharacterProperties', WordSearchCharacterProperties);
    angular.module('app.vue.components').value('WordSearchColorProperties', WordSearchColorProperties);
    angular.module('app.vue.components').value('WordSearchTester', WordSearchTester);
    angular.module('app.vue.components').value('WordSearchGridProperties', WordSearchGridProperties);
    // Calendar components
    angular.module('app.vue.components').value('CalendarGeneralProperties', CalendarGeneralProperties);
    angular.module('app.vue.components').value('CalendarMonthYearProperties', CalendarMonthYearProperties);
    angular.module('app.vue.components').value('CalendarDaysProperties', CalendarDaysProperties);
    angular.module('app.vue.components').value('CalendarSelectedDateProperties', CalendarSelectedDateProperties);
    // QR Code components
    angular.module('app.vue.components').value('QrCodeTester', QrCodeTester);
    angular.module('app.vue.components').value('QrCodeStyleProperties', QrCodeStyleProperties);
    angular.module('app.vue.components').value('QrCodeColorProperties', QrCodeColorProperties);
    angular.module('app.vue.components').value('ElementsLinkModal', ElementsLinkModal);
})();
